export default {
  exhibitors: {
    list_of_exhibitors: '企業一覧',
    find_an_exhibitor: '出展者を検索',
    import_exhibitor_database: '出展者データベースをインポート',
    action: '操作',
    simple_extraction: '簡易抽出',
    active: '有効',
    name_of_the_company: '会社名',
    retirer: '削除',
    annuler: 'キャンセル',
    confirm: '確認',
    edit: '編集',
    numero_de_stand: 'ブース番号＋ホール',
    participation: '参加形態',
    nom_commercial: '商号',
    my_company_is: '当社はフランスパビリオンに出展します',
    individual: '個別またはシェアブース（Business France経由）',
    sur_as_stand: '地域または業界団体の共同ブース',
    products_catalog: '製品カタログ',
    last_login: '最終ログイン',
    download: 'ダウンロード',
  },
};
